var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAccountHeader = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_user_account",
    d: "M-10.994-1.024A3.913,3.913,0,0,1-7.162,2.964a3.912,3.912,0,0,1-3.832,3.988,3.912,3.912,0,0,1-3.832-3.988A3.912,3.912,0,0,1-10.994-1.024Zm7.483,14.817c-.288-2.83-1.912-5.271-4.167-6.048a1.057,1.057,0,0,0-.915.2,3.715,3.715,0,0,1-4.767-.02,1.056,1.056,0,0,0-.913-.213c-2.262.756-3.906,3.181-4.218,6.009-.1.937.391,3.221,7.476,3.254S-3.416,14.731-3.511,13.793Z",
    transform: "translate(18.501 1.024)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAccountHeader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_account_header.891233ebfe37d67cb021b38b1543272f.svg";